
export const name = "MeetingsPublic";
export const version = "1.57850";
